// extracted by mini-css-extract-plugin
export default {"label":"PromotionEditModal_label__tq3kN"};